import angular from 'angular';
import uiRouter from 'angular-ui-router';
import enquiryListComponent from './enquiryList.component';

let enquiryListModule = angular.module('enquiryList', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('enquiryList', {
      url: '/enquiry/list',
      component: 'enquiryList',
      params: {
        vehicleConditionSearch: null
      }
    });
})

.component('enquiryList', enquiryListComponent)

.name;

export default enquiryListModule;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryList/enquiryList.js